import React, { useState } from 'react'
import { Gift } from '../styles/gift'
import GiftBody from './GiftBody'
import GiftHeader from './GiftHeader'
import { Container } from '../styles/elements'

export default ({
  background, description, instruction, price,
  isPaid, purchaseDate, expirationDate, code, score,
  id, icon, type,
}) => {

  const [isGiftScrolled, setGiftScrolled] = useState()
  const [clientY, setClientY] = useState()

  const wheelHandler = e => {
    e.stopPropagation()
    const isScrolledDown = (e.wheelDelta && e.wheelDelta < 0) || (e.deltaY && e.deltaY > 0)
    setGiftScrolled(isScrolledDown)
  }

  const touchStartHandler = e => {
    e.stopPropagation()
    e.touches && setClientY(e.touches[0].clientY)
  }

  const touchMoveHandler = e => {
    e.stopPropagation()
    const deltaY = e.changedTouches[0].clientY - clientY
    const threshold = 5
    const isScrolledDown = deltaY + threshold < 0
    setGiftScrolled(isScrolledDown)
  }

  const giftHeaderProps = {
    background, description, code,
    isPaid, purchaseDate, expirationDate,
    score, isGiftScrolled, type,
  }

  const giftBodyProps = {
    id, background, instruction, price, score, description, expirationDate,
    isPaid, icon,
  }
  return (
    <Container
      onWheel={wheelHandler}
      onTouchStart={touchStartHandler}
      onTouchMove={touchMoveHandler}
    >
      <Gift>
        <GiftHeader {...giftHeaderProps} />
        <GiftBody {...giftBodyProps} />
      </Gift>
    </Container>
  )
}
